import { ComponentProps, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';

export function useExploreNullState(hasFilters: boolean, expandable: boolean, onClearFilters: () => void, onZoomOut: () => void) {
  const nullState = useMemo(() => {
    const clearFilters: ComponentProps<typeof Button> = {
      onClick: onClearFilters,
      text: <FormattedMessage defaultMessage="Clear filters" />,
      variant: 'secondary'
    };
    const zoomOut: ComponentProps<typeof Button> = {
      onClick: onZoomOut,
      text: <FormattedMessage defaultMessage="Zoom out" />,
      variant: 'primary'
    };

    let ctas: ComponentProps<typeof Button>[] = [];
    if (hasFilters) {
      if (expandable) {
        ctas = [clearFilters, zoomOut];
      } else {
        ctas = [{ ...clearFilters, variant: 'primary' }];
      }
    } else {
      ctas = [zoomOut];
    }

    return {
      messaging: hasFilters ? (
        <FormattedMessage defaultMessage="Try fewer filters or zoom out" />
      ) : (
        <FormattedMessage defaultMessage="We haven’t added any verified routes here yet. Zoom out or try a new search." />
      ),
      ctas
    };
  }, [expandable, hasFilters, onClearFilters, onZoomOut]);

  return nullState;
}
